export const customisation = {
  listes: {
    table: {
      title: 'Liste déroulante',
      columns: {
        code: 'Code',
        name: 'Nom',
      },
    },
    fiche: {
      title: {
        edit_liste: 'Fiche de la liste {{ code }}',
        new_liste: "Création d'une nouvelle liste",
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
      },
      champ_titles: {
        code: 'Code',
        name: 'Nom',
      },
    },
    detail: {
      table: {
        title: 'Liste des valeurs de la liste déroulante {{list_code}}',
        buttons: {
          back: 'Retour',
        },
        columns: {
          code: 'Code',
          label: 'Libellé',
        },
      },
      fiche: {
        title: {
          edit: 'Fiche du champ {{value}}',
          new: "Création d'un champ de la liste",
        },
        champ_titles: {
          value: 'Valeur',
        },
        buttons: {
          back: 'Annuler',
          save: 'Sauvegarder',
        },
      },
    },
  },
  accounting_field: {
    table: {
      title: 'Liste des customisations comptables',
      columns: {
        label: 'Libellé',
        name: 'Nom du champs',
        visible: 'Visible',
        obligatory: 'Obligatoire',
        entered_size: 'Taille de saisie',
      },
    },
    modal: {
      remove: {
        title: 'Voulez-vous vraiment supprimer ce champ',
      },
    },
    fiche: {
      title: {
        edit: 'Fiche du champ',
        new: "Création d'une nouvelle zone comptable",
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
      },
      champ_titles: {
        mask: 'Masque',
        name: 'Nom du champs',
      },
    },
  },
  dynamic_method: {
    table: {
      title: 'Liste des méthodes dynamiques',
      title_drawer: 'Liste des interfaces',
      import_rules: "Import",
      export_rules: "Export",
      picto_name: 'Liaison',
      columns: {
        code: 'Code',
        name: 'Nom',
        state: 'Etat',
        update_timestamp: 'Date de modification',
      },
    },
    fiche: {
      title: {
        edit: 'Fiche de la méthode dynamique {{code}}',
        new: "Création d'une nouvelle méthode dynamique",
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
      },
      champ_titles: {
        state: 'Etat',
        code: 'Code',
        name: 'Nom',
        syntax: 'Syntaxe',
        dynamic_code: 'Code dynamique',
        keywords: 'Mots clés',
      },
    },
  },
  fiche: {
    title: {
      edit_title: "Modification d'un fiche custom",
      view_title: 'Fiche du tiers custom',
      new_title: "Création d'un fiche custom",
      cut_off: 'Cut-Off',
    },
    buttons: {
      back: 'Annuler',
      save: 'Valider',
      create: 'Valider',
      add: 'Ajouter',
    },
    champ_titles: {
      champnom: 'Nom du champ',
      pays: 'Pays',
      masque: 'Masque',
      type_custom: 'Type de champ',
      custom_filtre: 'Custom Filtre dans Fiche en valeur',

    },
  },
  table: {
    header: {
      title: 'Liste des customisations tiers',
      new_custom: 'Nouveau',
    },
    columns: {
      name: 'Nom du champ',
      libelle: 'Libellé',
      pays: 'Pays',
      isvisible: 'Visible',
      isobligatoire: 'Obligatoire',
      taille: 'Taille de saisie',
    },
  },
  correspondance: {
    table: {
      title: 'Liste des tables de correspondance',
      title_import_correspondance: 'Ajout des correspondances',
      columns: {
        code: 'Code',
        nom: 'Nom',
      },
    },
    fiche: {
      title: {
        edit: 'Fiche de la table de correspondance {{code}}',
        new: "Création d'une table de correspondance",
      },
      champ_titles: {
        code: 'Code',
        name: 'Name',
      },
    },
    fiche_champs: {
      title: {
        edit: 'Fiche de la table de correspondance {{entry_val}}',
        new: "Création d'un détail de correspondance",
      },
      champ_titles: {
        disloq_value: "Valeur d'entrée",
        out_value: 'Valeur de sortie',
        french: 'Français',
        english: 'Anglais',
      },
    },
    table_champs: {
      title: {
        edit: 'Liste des valeurs de la table de correspondance {{entry_val}}',
        new: "Création d'un détail de correspondance",
      },
      champ_titles: {
        id: 'Id',
        entry_code: 'Code entrée',
        out_code: 'Code sortie',
        libelle: 'Libellé',
      },
    },
  },
  email_template: {
    table: {
      title: 'Liste des modèles', // 'Liste des modèles de notifications',
      columns: {
        name: 'Nom',
        object: 'Objet',
        type: 'Type',
        update_timestamp: 'Date de modification',
      },
    },
    fiche: {
      title: {
        edit: 'Fiche du modèle {{code}}', // 'Fiche du modèle de notification {{code}}',
        new: "Création d'un modèle de notification",
        body: 'Corps du modèle',
      },
      champ_titles: {
        model_name: 'Nom du modèle',
        model_object: 'Objet du modèle',
        webhook_url: 'URL Webhook',
        notification_type: 'Type de notification',
        template_type: 'Type de template',
      },
    },
  },
  email_rule: {
    table: {
      title: 'Liste des règles de notifications',
      columns: {
        name: 'Nom',
        code: 'Code',
        flow: 'Flux',
        update_timestamp: 'Date de modification',
      },
    },
    fiche: {
      title: {
        edit: 'Modification des règles de notifications: {{code}}',
        new: 'Création de nouvelles règles de notifications',
        conditions: 'Conditions',
        smartags: 'Destinataires',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
      },
      champ_titles: {
        code: 'Code',
        name: 'Nom',
        flow: 'Flux',
        template: 'Template',
        batch_state: 'Etat lot',
        condition: 'Condition',
        value: 'Valeur',
        emails: 'Adresses emails',
        smartags_users: 'Smart Tags utilisateurs',
        email: "Langue d'envoi sur les emails saisis",
        smartags_grp_users: "Smart Tags groupe d'utilisateurs",
        smartags_grp_admins: "Smart Tags groupe d'administrateurs",
      },
    },
  },
  email_report_rule: {
    table: {
      title: "Liste des tâches programmées",
      titleModal: "Liste des valeurs",
      execute_imediat: "Exécution immédiate",
      columns: {
        name: 'Nom',
        code: 'Code',
        heure: 'Heure de lancement',
        update_timestamp: 'Date de modification',
        type: "Type",
        mode_envoi: "Mode envoi",
      },
      columnsMember: {
        name: 'Nom',
        code: 'Code',
      },
    },
    fiche: {
      title: {
        edit: "Modification d'une tâche programmée : {{code}}",
        new: "Création d'une tâche programmée ",
        conditions: 'Conditions',
        smartags: 'Email',
        state: "Tâches",
        connecteur: 'Connecteur',
        list_valeur: "Liste des valeurs",
        titleModal_currency: "Liste des devises",

      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
      },
      champ_titles: {
        code: 'Code',
        name: 'Nom',
        flow: 'Flux',
        template: 'Template',
        type_export: "Type",
        placeholder_type: "- Type d'export -",

        type: 'Type',
        condition: 'Condition',
        day: "Jours",
        treso: 'Etat trésorerie',
        interf: 'Interface',
        emails: 'Adresses emails',
        smartags_users: 'Smart Tags utilisateurs',
        email: "Langue d'envoi sur les emails saisis",
        utilisateur: "Utilisateurs",
        smartags_grp_admins: "Smart Tags groupe d'administrateurs",
        mond: "Lundi",
        tues: "Mardi",
        wed: "Mercredi",
        thur: "Jeudi",
        fri: "Vendredi",
        sat: "Samedi",
        sund: "Dimanche",
        user_reference: "Langue",
        reference_user: 'Utilisateur réfèrent',
        heure_lance: "Heure Lancement",
        mode_env: "Mode d'envoi",
        date: 'Date',
        user: 'Utilisateur Référent',
        last_month: 'Mois précédent'
      },
    },
  },
  custom_fields: {
    table: {
      title: 'Liste des masques de champs',
      columns: {
        code: 'Code',
        label: 'Libellé',
        liste: 'Liste',
        visible: 'Visible',
        obligatory: 'Obligatoire',
        entered_size: 'Taille de saisie',
      },
    },
    buttons: {
      new: 'Nouveau Lot',
      delete: 'Confirmez-vous la suppression',
    },
    fiche: {
      save: 'Valider',
      create: 'Valider',
      creation_title: "Création d'un nouveau masque de champ",
      edit: 'Fiche du masque de champ {{code}}',
      forme: {
        code: 'Code',
        code_label: 'Code du masque du champ',
        visible: 'Visible',
        size_forme: 'Taille de saisie',
        size_forme_label: 'Taille de saisie du champ',
        list: 'Liste',
        fr: 'Français',
        fr_label: 'Libellé du champ de saisie',
        fr_label_txt: "Texte d'indication du champ de la langue ci-dessus",
        type_champ: 'Type de champ',
        obligatoire: 'Obligatoire',
        edit_saisie: 'Modifiable en saisie',
        masque: 'Masque de saisie',
        en: 'English',
        el_placeholder: 'Libellé du champ de saisie',
        en_label: "Texte d'indication du champ de la langue ci-dessus",
        fr_trad: "Français",
        en_trad: "English",
        es_trad: "Español"
      },
    },
  },
};
